import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUsers: (state, action) => {
      state.users = action.payload.users;
    },
    clearUser:(state, action) => {
      state.users = [];
    },
    tempUser: (state, action) => {
      state.temp = action.payload.temp;
    }
  },
});

export const { getUsers, clearUser, tempUser } = userSlice.actions;
export default userSlice.reducer;
